import { render } from "./BoqRatesItems.vue?vue&type=template&id=7c8dc5f8"
import script from "@/assets/boq/BoqRateItems.js?vue&type=script&lang=js"
export * from "@/assets/boq/BoqRateItems.js?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__